module.exports = __webpack_public_path__ + "img/9788998515065.9bcfb012.jpg";